/* eslint-disable @next/next/no-img-element */
import React from 'react';
import { Popover } from 'antd';
import IconFont from '$/components/IconFont';
import { useOfficialStore } from '$/store/useOfficialStore';
import styles from './index.module.scss';

/** 官网优先使用请求国家码保证 SSR 一致，其他调用方继续读取 Store；巴西展示 WhatsApp，其余展示 Discord。 */
export default function DiscordBtn({ countryCode }: { countryCode?: string; }) {
  const currentCountryCode = useOfficialStore((state) => countryCode ?? state.currentCountryCode);
  const isBrazilCountry = currentCountryCode?.toUpperCase() === 'BR';

  /** 打开 Discord 社区邀请链接。 */
  const joinDiscord = () => {
    window.open('https://discord.gg/JXt2gwDpVp', '_blank');
  };

  return (
    isBrazilCountry
      ? (
        <Popover
          placement="bottom"
          trigger={['hover']}
          content={(
            <div className={styles.wechatQrcodeContent}>
              <img src="https://titan-img.meitudata.com/roboneo/image/home/brazil_qrcode.png" alt="" crossOrigin="anonymous" />
            </div>
                  )}
          overlayClassName="resetPopoverAndArrow"
        >
          <div className={styles['product-item']}>
            <div
              style={{
                width: '40px',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
              }}
            >
              <IconFont
                className={styles['product-item-icon']}
                fontSize={16}
                name="logoWhatsappFill"
              />
            </div>
          </div>
        </Popover>
      )
      : (
        <div className={styles['product-item']} onClick={joinDiscord}>
          <div
            style={{
              width: '40px',
              display: 'flex',
              alignContent: 'center',
              justifyContent: 'center',
            }}
          >
            <IconFont
              className={styles['product-item-icon']}
              fontSize={16}
              name="discord"
            />
          </div>
        </div>
      )
  );
}
